/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./accountMgmtOverview.vue?vue&type=template&id=3bdde376&scoped=true"
import script from "./accountMgmtOverview.vue?vue&type=script&lang=js"
export * from "./accountMgmtOverview.vue?vue&type=script&lang=js"
import style0 from "./accountMgmtOverview.vue?vue&type=style&index=0&id=3bdde376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdde376",
  null
  
)

export default component.exports